import { Button, Form } from "@/atoms"
import { PlayCircleOutlined } from "@/icons"
import { isValidSlackWebhookUrl } from "@/pages/IntegrationsPage/helpers/slack"

import type { TestSlackButtonProps } from "."

export const TestSlackButton = (props: TestSlackButtonProps) => {
  const { form, t, channel, size, onTest, isTesting, isPending } = props
  const url: string | undefined = Form.useWatch("url", form)
  const typed = url?.trim()
  const canTest = typed ? isValidSlackWebhookUrl(typed) : !!channel

  return (
    <Button
      size={size}
      icon={<PlayCircleOutlined />}
      type="default"
      loading={isTesting}
      disabled={!canTest || isPending}
      onClick={() => onTest(typed)}
    >
      {t("integrations.slack.form.buttons.test")}
    </Button>
  )
}
